export const ACESSIBILIDADE = 'ACESSIBILIDADE';
export const ACESSIBILIDADE_START = 'ACESSIBILIDADE_START';
export const ACESSIBILIDADE_SUCCESS = 'ACESSIBILIDADE_SUCCESS';
export const ACESSIBILIDADE_ERROR = 'ACESSIBILIDADES_ERROR';
